module.exports = __webpack_public_path__ + "static/tat-42-eaf5356846f9636a7ca78ec055511126.jpg";